// 소수 없는 통화는 정수 반올림, 그 외 2자리. (KRW/JPY 포함하므로 필요.)
const ZERO_DECIMAL = new Set(["KRW", "JPY"]);

/**
 * 통화 단위로 반올림한다.
 *
 * 주문 라인 `discount` 는 뺄셈·덧셈으로 만들어져 부동소수 오차(`47.73000000000002`)가 그대로 저장돼 어드민·SALES 에
 * 노출됐다(2026-11-05 현우님 보고 — GE `261105-1603-DE-JHR`, PayPal `261105-1231-US-SLH`). 카탈로그 `discountAmount`
 * 자체가 admin 의 「판매가 입력 → 정가 − 판매가 역산」으로 오차를 갖고 오기도 한다(`docs/order-item-pricing.md`).
 * 그래서 **draft 라인에 저장하는 지점**(`OrderService` · `send-order` · `applyIssuedCoupon`)에서 이 함수로 맞춘다.
 */
export function roundMoney(amount: number, currency: string): number {
  if (ZERO_DECIMAL.has(currency)) return Math.round(amount);
  return Math.round(amount * 100) / 100;
}

export function isZeroDecimalCurrency(currency: string): boolean {
  return ZERO_DECIMAL.has(currency);
}
